module.exports = __webpack_public_path__ + "static/media/share.edddc4df.svg";